<div class="min-h-screen max-w-320 mx-auto py-8 px-4 sm:px-8 sm:py-16">
    <div class="grid grid-cols-2">
        <div class="col-span-2 md:col-span-1 max-w-100 w-full mx-auto">
            <div *ngIf="step == 'restore-account'">
                <h3 class="text-4xl font-medium">Account Recovery</h3>
            </div>
            <div *ngIf="step == 'set-new-password'">
                <h3  class="text-4xl font-medium">Set a new password</h3>
                <p class="mb-3">Secure your account with a strong password.</p>
            </div>

            <div class="bg-white dark:bg-slate-800 w-full mx-auto p-8 rounded-xl">
                <div *ngIf="step == 'restore-account'">

                    <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                        <mat-icon matIconPrefix [svgIcon]="'tabler_outline:mail'"></mat-icon>
                        <mat-label>Account email address</mat-label>
                        <input type="email" matInput lowercaseEmail [formControl]="restoreForm.controls.emailAddress"  placeholder="Enter your email address">
                            <mat-error *ngIf="restoreForm.controls.emailAddress.hasError('required')">Email address is required.</mat-error>
                            <mat-error *ngIf="restoreForm.controls.emailAddress.hasError('invalidEmail')">Invalid email format.</mat-error>
                    </mat-form-field>
    
                    <button [disabled]="isProcessing" mat-flat-button color="primary" class="w-full mt-4" (click)="restore()">
                        Recover Access
                    </button>
                </div>
    
                <div *ngIf="step == 'set-new-password'">
                      
                        <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                            <mat-icon matIconPrefix [svgIcon]="'tabler_outline:lock'"></mat-icon>
                            <mat-label>New password</mat-label>
                            <input [type]="showPassword ? 'text' : 'password'" matInput  [formControl]="newPasswordForm.controls.password"  placeholder="Enter new password">
                            <button mat-icon-button matSuffix (click)="showPassword = !showPassword">
                                <mat-icon [svgIcon]="showPassword ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"></mat-icon>
                            </button>
                            <mat-error *ngIf="newPasswordForm.controls.password.hasError('required')">Field is required</mat-error>
                            <mat-error *ngIf="newPasswordForm.controls.password.hasError('minlength')">Password must be at least 8 characters long.</mat-error>
                              
                        </mat-form-field> 
                       
                      
                        <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                            <mat-icon matIconPrefix [svgIcon]="'tabler_outline:lock'"></mat-icon>
                            <mat-label>Repeat new password</mat-label>
                            <input [type]="showRepeatPassword ? 'text' : 'password'" matInput [formControl]="newPasswordForm.controls.repeatPassword"  placeholder="Repeat new password">
                            <button mat-icon-button matSuffix (click)="showRepeatPassword = !showRepeatPassword">
                                <mat-icon [svgIcon]="showRepeatPassword ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"></mat-icon>
                            </button>
                            <mat-error *ngIf="newPasswordForm.controls.repeatPassword.hasError('matchFields')">Passwords do not match.</mat-error>
                        </mat-form-field>
                       
    
                    <button [disabled]="isProcessing"  mat-flat-button color="primary" class="w-full mt-4" (click)="setNewPassword()">
                        Set New Password
                    </button>
                </div>
            </div>
            
            <button class="my-8" color="primary" mat-button [routerLink]="'/login'">
                Login
                <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:chevron-right'"></mat-icon>
            </button>
        </div>

        <div class="col-span-2 md:col-span-1 md:mt-6">
            <div class="max-w-120 w-full mx-auto">
                <h4 class="text-4xl mt-4">Instructions</h4>
                <div class="p-4 rounded-lg bg-primary text-white border-l-4 dark:border-primary-300 border-primary-900">
                    <div class="flex">
                        <div class="ml-3">
                            <div class="text-base">
                                <ul role="list" class="list-disc pl-5 space-y-1" *ngIf="step == 'restore-account'">
                                    <li>Enter the email address associated with your account.</li>
                                    <li>If you entered a correct email address, a one-time link will be sent to that address. Also, check your SPAM folder.</li>
                                    <li>Click the link in the email and enter your new account password.</li>
                                </ul>
                                <ul role="list" class="list-disc pl-5 space-y-1" *ngIf="step == 'set-new-password'">
                                    <li>Secure your account with a strong password!</li>
                                    <li>The password should contain at least <b>8 characters</b>.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>